export default {

	apiGateway: {
		REGION: "us-east-1"
		, URL: "https://vbwthsub6g.execute-api.us-east-1.amazonaws.com/prod/"
		//, URL: "https://api.bukhu.com/"
	}
	, cognito: {
		REGION: "us-east-1"
		, USER_POOL_ID: "us-east-1_jxhmE97XD"
		, APP_CLIENT_ID: "3qe0r1vq91aqnrbv24lp3ho3ur"
		, IDENTITY_POOL_ID: "us-east-1:fc12c65e-bf67-468c-abfb-b3d0fd8c78ff"

	}
	, oauth: {
		// Domain name
		domain: 'bukhu.auth.us-east-1.amazoncognito.com',

		// Authorized scopes
		scope: ['email', 'profile', 'openid', 'contacts'],

		// Callback URL
		redirectSignIn: 'https://localhost:3000/login',

		// Sign out URL
		redirectSignOut: 'https://localhost:3000/logout',

		// 'code' for Authorization code grant, 
		// 'token' for Implicit grant
		responseType: 'token',

		// optional, for Cognito hosted ui specified options
		options: {
			// Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
			AdvancedSecurityDataCollectionFlag: true
		}
	}
	, social: {
		//FACEBOOK_APPID: '1672861612830938' //BukHu
		FACEBOOK_APPID: '573595222653221' //CarpeTeknus
		, AMAZON_APPID: 'amzn1.application-oa2-client.991553f24939460a820b992d2645cf52'
		, GOOGLE_APPID: '704732290283-m2o0fvu8lj0sfkiedfcp185lktfbpkug.apps.googleusercontent.com'
		, GOOGLE_APIKEY: 'AIzaSyCNUQpCzEX7_ZtUpby0_UEj1IgJHse06M0'
		
	}
};



// WEBPACK FOOTER //
// ./src/config.js